import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api, FALLBACK_PRODUCTS } from "@/lib/api";
import { ProductCard } from "./ProductCard";

export const Collection = () => {
  const [products, setProducts] = useState(FALLBACK_PRODUCTS);

  useEffect(() => {
    let active = true;
    api.get("/products")
      .then((res) => { if (active && Array.isArray(res.data) && res.data.length) setProducts(res.data); })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  return (
    <section id="collection" className="px-5 md:px-14 lg:px-20 pt-20 md:pt-28 pb-8 md:pb-12" data-testid="collection-section">
      <motion.div
        initial={{ opacity: 0.001, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
        className="grid md:grid-cols-12 gap-8 mb-16 md:mb-20"
      >
        <p className="label md:col-span-3">I — The Collection</p>
        <h2 className="md:col-span-6 font-serif text-bone font-light text-5xl md:text-7xl leading-[0.95]">
          Objects cast from<br /><em>deep time.</em>
        </h2>
        <p className="body md:col-span-3 md:self-end">
          Each piece is hand-cast in mineral composite. While the geometry is precise, 
          the swirl of pigment and stone density can never be repeated, making every 
          object a single edition of its moment.
        </p>
      </motion.div>
      
      {/* Griglia compattata: pb-8/12 elimina il buco nero in fondo */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 lg:gap-x-28 gap-y-12 items-start" data-testid="product-grid">
        {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
      </div>
    </section>
  );
};